import { defineStore } from 'pinia'
import { useRequest } from 'composables/useRequest.js'

const CACHE_TTL = 5 * 60 * 1000 // 5 minutes

export const useAvailabilityStore = defineStore('availability', {
  state: () => ({
    calendar: null,   // primary calendar: id, start_at_hour, end_at_hour, day flags
    fetchedAt: null,
    loading: false,
    error: null,
  }),

  getters: {
    isCacheValid: (state) =>
      state.fetchedAt !== null && Date.now() - state.fetchedAt < CACHE_TTL,
  },

  actions: {
    async fetchIfStale() {
      if (this.isCacheValid && this.calendar) return
      await this.fetchCalendar()
    },

    async fetchCalendar() {
      this.loading = true
      this.error = null
      try {
        const { axiosRequest } = useRequest()
        const res = await axiosRequest('GET', '/api/v1/calendar/availability', {}, false)
        if (!res.js_error && res.response.success) {
          this.calendar = res.response.data
          this.fetchedAt = Date.now()
        } else {
          this.error = 'Failed to load availability settings.'
        }
      } catch {
        this.error = 'Something went wrong.'
      } finally {
        this.loading = false
      }
    },

    // Call after a successful save to keep the cache in sync
    updateCalendar(patch) {
      if (this.calendar) Object.assign(this.calendar, patch)
      this.fetchedAt = Date.now()
    },

    invalidate() {
      this.fetchedAt = null
    },
  },
})
